"use client";

import { useParams, useRouter } from "next/navigation";
import { useEffect } from "react";

export default function SubdomainHomeRedirect() {
  const params = useParams<{ subdomain: string }>();
  const router = useRouter();

  useEffect(() => {
    if (params.subdomain) {
      router.replace(`/${params.subdomain}/threads`);
    }
  }, [params.subdomain, router]);

  return null;
}
